import styled from 'styled-components';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { Typography } from '@mui/material';
import { FlexColumn } from '../../Flex';
import IconButton from '../../IconButton';
import { fontSize, lineHeight, space } from '../../../style/utils';

const Container = styled(FlexColumn)`
  align-items: center;
  gap: ${space('md')};
  padding: ${space('lg')};
  margin: ${space('lg', 0)};
`;

const MessageText = styled(Typography)`
  font-size: ${fontSize('base')};
  color: ${({ theme }) => theme.palette.content.translucent.secondary};
  text-align: center;
  line-height: ${lineHeight('none')};
`;

const ContinueButton = styled(IconButton)`
  border: 1px solid ${({ theme }) => theme.palette.border.default} !important;
  background: ${({ theme }) => theme.palette.surface.base} !important;
  padding: ${space('sm', 'lg')};
  gap: ${space('sm')};

  :hover {
    background: ${({ theme }) => theme.palette.surface.hover} !important;
    border-color: ${({ theme }) => theme.palette.border.default} !important;
  }
`;

type Props = {
  onContinue: () => void;
  disabled?: boolean;
};

const StuckMessage = ({ onContinue, disabled = false }: Props) => (
  <Container>
    <MessageText>
      There&apos;s a connection issue.
      <br />
      <br />
      Try continuing again in a couple of moments.
    </MessageText>
    <ContinueButton
      onClick={onContinue}
      disabled={disabled}
      variant="outlined"
      aria-label="Retry conversation"
    >
      <RefreshRoundedIcon
        sx={{
          fontSize: fontSize('xxl'),
          color: 'content.translucent.secondary',
        }}
      />
      <Typography sx={{ color: 'content.translucent.secondary' }}>
        Retry
      </Typography>
    </ContinueButton>
  </Container>
);

export default StuckMessage;
